import { render, staticRenderFns } from "./ShortcutBoard.vue?vue&type=template&id=1c27edbf&scoped=true"
import script from "./ShortcutBoard.vue?vue&type=script&lang=js"
export * from "./ShortcutBoard.vue?vue&type=script&lang=js"
import style0 from "./ShortcutBoard.vue?vue&type=style&index=0&id=1c27edbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27edbf",
  null
  
)

export default component.exports